
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Optimisation du Quality Score sur Google Ads : les conseils d’ALEO",
    description:
      "Améliorez votre Quality Score Google Ads avec nos astuces. Découvrez comment optimiser vos annonces pour améliorer les performances et ainsi réduire les coûts.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
